module.exports = __webpack_public_path__ + "static/media/tour-compl-0.e0a64ca7.png";